import { useOktaAuth } from '@okta/okta-react'
import axios from 'axios'
import { api } from 'config'
import { useCallback, useState } from 'react'

export function useCheckAndUpdateOktaUser() {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)

  const { authState } = useOktaAuth()

  const execute = useCallback(
    async (memberId: string) => {
      setLoading(true)
      setError(false)
      setSuccess(false)
      try {
        await axios.get(api.switchOktaMemberAccount(memberId), {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        setSuccess(true)
      } catch (err) {
        setError(true)
      }
      setLoading(false)
    },
    [authState?.accessToken?.accessToken],
  )

  return { loading, success, error, execute }
}
